import createFormStore from '@common/stores/createFormStore';

const formStore = createFormStore({
  endpoint: `/invite-friends/track-post`,
  fields: {
    post_link: '',
    activity_name: 'mentee_shared_metric_shareable_stats',
  },
  name: 'stats.earnCoinFormStore',
});

export const { actionTypes } = formStore;

export const { actions } = formStore;

const { reducer } = formStore;

export default reducer;
